

import { Component, OnInit, Input } from '@angular/core';
import { SetService, EventService, HttpService, PageService, FormControlService } from 'ngx-block-core';
import { NzModalService, NzMessageService, NzNotificationService } from 'ng-zorro-antd';
import { eventType2, selectSize, selectThemeSize, iconTheme } from "../../../data/data";
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sucu05-button0010007',
  templateUrl: './sucu05-button0010007.component.html',
  styles: [

  ]
})
export class Sucu05Button0010007Component implements OnInit {

  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() isVisible = false;
  @Input() sets = {
    blockCode: "sucublock52",
    blockId: "",
    blockName: "功能按钮",
    layoutId: "",
    blockType: 'formButton',
    blockChildType: '',
    versionCode: 18,
    events: [
      {
        label: "隐藏",
        value: "pageShow",
        data: {
          setParams: ["隐藏值", '显示值，可不填', '备用']
        }
      },
      {
        label: "快速模式切换",
        value: "fastForm",
        data: {
          setParams: ["快速值", '转圈值', '备用']
        }
      }
    ],
    styles: {
      nzText: "功能",
      nzType: "default",
      nzSize: "default",
      nzBgColor: "",
      nzIcon: {
        nzIconType: '',
        nzIconTheme: '',
        nzIconColor: '',
      },
      nzOpen: true,
      nzConfirm: {
        nzShow: false,
        nzTitle: "提示",
        nzContent: "确定吗？"
      },
      nzShow: true,
      nzShowValue: "",
      nzFastClick: false,
      nzFastData: {
        nzResetId: "",
        nzResetFormName: ""
      },
    },
    datas: {
      nzFormCheck: false,
      nzLog: "",
      nzLogSet: {
        defaultTitle: "SN:"
      },
      nzFocus: {
        nzFocus1: "",
        nzFocus2: "",
        nzFocus3: "",
      },
      nzECO: true,
      nzSIC: "",
      nzReset: false,
      nzDataSource: "",
      nzEvents: [

      ],
      nzOtherFormCheck: [],
      nzEventsDatas: {
      },
      nzJumpMode: "none",
      nzProcedure: {
        nzProcedureIsNeed: false,
        nzProcedureTriggerPosition: "default",
        nzProcedureName: "",
        nzProcedureView: "",
        nzServiceParam: [],
        nzServiceParamDetail: { "sequ": 1 }

      },
      nzOtherData: [],
      // nzJumpType: "self",
      // nzJumpPageType: 0,
      // nzJumpPage: "",
      // nzJumpMode: "none",
      // nzJumpModalTitle: "",
      // nzJumpModalWidth: 520,
      // nzSenceSelectValue: [],
      // nzSenceValue: [],
      // nzVirtualSenceSelectValue: [],
      // nzVirtualSenceValue: [],
      // nzSenceJson: [],

    }
  };
  @Input() httpUrls = {
    dynamicProcedure: {
      needChange: true,
      url: "/system/dynamicProcedure",
      name2: "proData",
    },
  }
  setData = []
  setDataInit() {
    this.setData = [
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'input',
                inputs: {
                  nzText: "按钮名称 : ", nzKeys: ['styles', 'nzText']
                }
              },
              {

                name: 'select',
                inputs: {
                  nzText: "主题 : ", nzKeys: ['styles', 'nzType'], nzData: selectThemeSize
                }
              },
              {
                name: 'radio',
                inputs: { nzText: "图标主题:", nzKeys: ['styles', 'nzIcon', 'nzIconTheme'], nzData: iconTheme, },
                outputs: {
                  ngModelChange: (event) => {


                    if (event == 'twotone') {

                      this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = true;

                    } else {
                      this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = false;

                    }


                    this.setService.onReLoadbBlock(this.layoutid);

                  }
                }
              },
              {
                name: 'input',
                inputs: { nzText: "图标 : ", nzKeys: ['styles', 'nzIcon', 'nzIconType'], nzPopContent: ['填入type,请参照官方文档:', 'https://ng.ant.design/components/icon/zh'] },
                outputs: { ngModelChange: () => { if (this.sets.styles.nzIcon.nzIconType == '') this.setService.onReLoadbBlock(this.layoutid) } }
              },
              {
                name: 'color', show: this.sets.styles.nzIcon.nzIconType == 'twotone',
                inputs: {
                  nzText: "图标颜色 : ", nzKeys: ['styles', 'nzIcon', 'nzIconColor']
                }
              },

              {
                name: 'color',
                inputs: {
                  nzText: "背景颜色 : ", nzKeys: ['styles', 'nzBgColor']
                }
              },
              {
                name: 'radio',
                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
              },
              {
                name: 'switch',
                inputs: { nzText: "开放按钮 : ", nzKeys: ['styles', 'nzOpen'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "显示按钮 : ", nzKeys: ['styles', 'nzShow'] }
              },

              {
                name: 'switch',
                inputs: { nzText: "快速提交 : ", nzKeys: ['styles', 'nzFastClick'] }
              },
              {
                name: 'select',
                inputs: { nzText: "快速提交积木 : ", nzKeys: ['styles', 'nzFastData', 'nzResetId'], nzData: this.setService.getBlock('formBlock', "*") },
              },
              {
                name: 'input',
                inputs: { nzText: "积木FormId : ", nzKeys: ['styles', 'nzFastData', 'nzResetFormName'], nzPopContent: ['请前往积木的表单配置页查找'] },
              },
              { name: 'nzConfirm' },
            ]
          },
        ]
      },
      {
        tabName: '操作',
        datas: [
          {
            type: 'datas',
            data: [

              { name: 'nzJumpPage', }
            ]
          },
        ]
      },
      {
        tabName: '功能',
        datas: [
          {
            type: 'datas',
            data: [
              {
                name: "nzEvents",
                inputs: { eventType: eventType2 }
              },
              { name: "nzOtherFormCheck" },
              { name: "nzDrawerLog" },
              {
                name: 'switch',
                inputs: { nzText: "重置表单 : ", nzKeys: ['datas', 'nzReset'] }
              },
              {
                name: 'select',
                inputs: { nzText: "SIC积木 : ", nzKeys: ['datas', 'nzSIC'], nzData: this.setService.getBlock('table', "*") },
              },
              {
                name: 'switch',
                inputs: { nzText: "ECO : ", nzKeys: ['datas', 'nzECO'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "表单校验 : ", nzKeys: ['datas', 'nzFormCheck'] }
              },

            ]
          },
        ]
      },
      {
        tabName: '业务存储',
        datas: [
          {
            type: 'datas',
            data: [

              {
                name: 'nzProcudure',
                inputs: { nzProcedure: this.sets.datas.nzProcedure, nzServiceParam: this.sets.datas.nzProcedure.nzServiceParam, nzServiceParamDetail: this.sets.datas.nzProcedure.nzServiceParamDetail }
              },
              {
                name: 'nzServiceParam',
                inputs: { nzProcedure: this.sets.datas.nzProcedure, nzServiceParam: this.sets.datas.nzProcedure.nzServiceParam, nzServiceParamDetail: this.sets.datas.nzProcedure.nzServiceParamDetail, nzNeedProcedure: true }
              },
              {
                name: 'nzOtherData',
              },

              {
                name: 'select',
                inputs: { nzText: "存储焦点1 : ", nzKeys: ['datas', 'nzFocus', 'nzFocus1'], nzData: this.setService.getBlock('formBlock', "*") },
              },
            ]
          },
        ]
      },
    ]
  }




  constructor(
    public setService: SetService,
    public eventService: EventService,
    private message: NzMessageService,
    private modalService: NzModalService,
    private httpService: HttpService,
    private pageService: PageService,
    private notification: NzNotificationService,
    private activatedRoute: ActivatedRoute,
    private formControlService: FormControlService

  ) { }
  formLayout = true;
  path
  ngOnInit() {
    this.path = this.pageService.getPathByRoute(this.activatedRoute);

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== '{}') {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.autoUpdate();
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }
        this.setService.blockPublicSets[this.blockid + "Urls"] = this.httpUrls;

      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
        this.autoUpdate();
      }
    }
    if (typeof this.setService.pageDatas['form_' + this.layoutid] == 'undefined') {
      this.formLayout = false;
    }
    this.Listening();

  }

  autoUpdate() {

    //v3,升级自定义表单参数
    if (this.sets.versionCode < 2) {

      this.sets.blockCode = "sucublock52";

      this.sets.versionCode = 2;
    }

    //v3,存储过程
    if (this.sets.versionCode < 3) {
      if (typeof this.sets.datas.nzProcedure == "undefined") {
        this.sets.datas['nzProcedure'] = {
          nzProcedureIsNeed: false,
          nzProcedureTriggerPosition: "default",
          nzProcedureName: "",
          nzProcedureView: "",
          nzServiceParam: [],
          nzServiceParamDetail: { "sequ": 1 }
        }
      }
      this.sets.versionCode = 3;
    }
    // V4 按钮开放
    if (this.sets.versionCode < 4) {

      this.sets.styles['nzOpen'] = true;

      this.sets.versionCode = 4;
    }
    // V5 按钮确认
    if (this.sets.versionCode < 5) {

      this.sets.styles['nzConfirm'] = {
        nzShow: false,
        nzTitle: "提示",
        nzContent: "确定要删除吗？"
      };

      this.sets.versionCode = 5;
    }

    //v6 条数限制
    if (this.sets.versionCode < 6) {

      if (typeof this.sets.datas.nzJumpMode == "undefined") {

        this.sets.datas.nzJumpMode = "none";
      }

      this.sets.versionCode = 6;
    }
    //vc:7
    //附加事件大整改
    if (this.sets.versionCode < 7) {
      for (const key in this.sets.datas.nzEventsDatas) {
        const element = this.sets.datas.nzEventsDatas[key];
        element['dataArray'] = [
          element['datas']
        ];
        element['dataArray'][0]['blockid'] = element['blockid']


      }

      this.sets.versionCode = 7;
    }

    if (this.sets.versionCode < 9) {

      this.sets.datas['nzLog'] = ""

      this.sets.datas['nzLogSet'] = {
        defaultTitle: "SN:"
      },

        this.sets.versionCode = 9;
    }
    if (this.sets.versionCode < 10) {

      this.sets.styles['nzShow'] = true;
      this.sets.styles['nzShowValue'] = "";
      this.sets.events = [
        {
          label: "隐藏",
          value: "pageShow",
          data: {
            setParams: ["隐藏值", '显示值，可不填', '备用']
          }
        }
      ]
      this.sets.versionCode = 10;
    }

    // V7 按钮开放
    if (this.sets.versionCode < 11) {

      this.sets.datas['nzOtherFormCheck'] = [];

      this.sets.versionCode = 11;
    }

    // V12 表单重置
    if (this.sets.versionCode < 12) {

      this.sets.datas['nzReset'] = false;

      this.sets.versionCode = 12;
    }
    if (this.sets.versionCode < 13) {
      this.sets.styles['nzFastClick'] = false;
      this.sets.styles['nzFastData'] = {
        nzResetId: "",
        nzResetFormName: ""
      }

      this.sets.versionCode = 13;
    }
    if (this.sets.versionCode < 14) {

      this.sets.events = [
        {
          label: "隐藏",
          value: "pageShow",
          data: {
            setParams: ["隐藏值", '显示值，可不填', '备用']
          }
        },
        {
          label: "快速模式切换",
          value: "fastForm",
          data: {
            setParams: ["快速值", '转圈值', '备用']
          }
        }
      ],

        this.sets.versionCode = 14;
    }

    if (this.sets.versionCode < 15) {

      this.sets.datas['nzECO'] = true;
      this.sets.datas['nzSIC'] = '';
      this.sets.versionCode = 15;
    }
    if (this.sets.versionCode < 16) {

      this.sets.datas['nzFocus'] = {
        nzFocus1: "",
        nzFocus2: "",
        nzFocus3: "",
      }
      this.sets.versionCode = 16;
    }
    if (this.sets.versionCode < 17) {

      this.sets.datas['nzFormCheck'] = false;
      this.sets.versionCode = 17;
    }

    if (this.sets.versionCode < 18) {

      this.sets.datas['nzOtherData'] = [];
      this.sets.versionCode = 18;
    }

  }

  private nzTimer;
  nzLoading = false;
  endEvent = [];
  async onClickEvents() {
    console.log("调用检测")
    this.endEvent = [];
    this.setService.addNeedStatus(this.blockid, 'submit', this.blockid, 'submit')
    this.setService.setPublicStatus(this.blockid, 'submit', 'submit')
    this.pageService.pageSpin[this.layoutid]['div'] = true;
    this.nzLoading = true;
    this.sets.datas.nzEvents.forEach(element => {
      switch (element) {
        case 'workflow':
          this.eventService.flowStatusTransfer(this.sets.datas.nzEventsDatas[element]['dataArray'][0]['blockid'], this.blockid)
          break;
        case 'form_reset':
          this.eventService.form_reset(this.formLayout, this.layoutid, this.activatedRoute)
          break;
        case 'dialog_close':
          this.eventService.dialog_close();
          break;
        case 'sendSimpleEvent':
          this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
            if (itemEvents['order'] == "front") {
              switch (itemEvents['name']) {
                case 'search':
                  break;
                default:
                  let senddata = { value: "" };
                  try {
                    senddata['param0'] = itemEvents['param0'];
                    senddata['param1'] = itemEvents['param1'];
                    senddata['param2'] = itemEvents['param2'];
                  } catch (error) {

                  }
                  console.log("send", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                  this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                  break;
              }
            } else {
              if (this.endEvent.indexOf(element) < 0) this.endEvent.push(element);
            }
          });
          break;
        default:
          break;
      }
    });
    //判断是否需要调用存储过程
    if (this.sets.datas.nzProcedure.nzProcedureIsNeed) {
      this.setService.addNeedStatus(this.blockid, 'submit', this.blockid, 'procedure')
      this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes')

      let serviceparams = this.pageService.getAllServiceParam(this.sets.datas['nzProcedure'], this.sets.datas['nzProcedure']['nzServiceParamDetail'], this.activatedRoute)
      console.log("获取业务参数1", serviceparams)
      serviceparams = await this.pageService.changeBodySn(serviceparams);
      console.log("获取业务参数2", serviceparams)
      let procedureParams = {
        dynamicSql: serviceparams[0].name,
        paramMap: serviceparams[0].compositeValue
      }
      console.log("resourceVerificationBean", this.pageService.pageDatas[this.path])
      if (typeof this.pageService.pageDatas[this.path] != "undefined" && typeof this.pageService.pageDatas[this.path]['SICBean'] != "undefined" && this.pageService.pageDatas[this.path]['SICBean'] != "") {
        procedureParams['resourceVerificationBean'] = this.pageService.pageDatas[this.path]['SICBean'];
      }

      //2.其它参数
      let resCode =
        await this.pageService.addProcedureParams(this.sets.datas.nzOtherData, procedureParams.paramMap);
      console.log("获取处理业务参数2", resCode, JSON.stringify(procedureParams), this.pageService.pageDatas[this.path])

      if (resCode !== 'ok') {
        console.log("获取参数失败resCode", resCode);
        this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes', -1)
        return;
      }

      this.httpService.postHttp(this.httpUrls.dynamicProcedure.url, procedureParams).subscribe(
        (data: any) => {
          console.log("Procedure成功", data)
          if (this.sets.datas.nzReset) {
            this.formControlService.form_Reset(this.setService.pageDatas['form_' + this.layoutid], this.setService.pageDatas['form_data_' + this.layoutid], this.activatedRoute);
          }
          console.log("Procedure成功-doAfterProcedure")

          this.pageService.doAfterProcedure(data, this.sets);
          this.pageService.doAfterProceduresecond(data, this.sets, this.activatedRoute);

          try {
            if (data.data[0]['CSYS_RETURN'] == 'fail')
              this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes', -1)
            else
              this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes', 1)
          } catch (error) {
            this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes', 1)

          }


          console.log(data.data);
        },
        (err: any) => {
          this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes', -1)
        });
    }
    this.setService.setPublicStatus(this.blockid, 'submit', 'submit', 1);
    setTimeout(() => {

      this.nzTimer = setInterval(() => {
        let res = 1, fail = 0;
        for (const key in this.setService.publicStatus[this.blockid]['submit']) {
          const element = this.setService.publicStatus[this.blockid]['submit'][key];
          if (element == -1) {
            fail = 1;
            this.message.create('success', `error` + key);
            this.nzLoading = false;
            this.pageService.pageSpin[this.layoutid]['div'] = false;
            //this.notification.blank('失败', key + '');
            if (this.nzTimer) {
              clearInterval(this.nzTimer);
              this.nzTimer = null
            }

          } else {
            if (element == 1) {
              console.log('成功', key);
              //this.notification.blank('成功', key + '');
              delete this.setService.publicStatus[this.blockid]['submit'][key];
            }
            res = res * element
          }
        }
        if (fail == 0) {
          if (res == 1) {
            //全成功
            console.log('全成功');
            //this.notification.blank('全成功', '全成功');
            // this.message.create('success', `处理成功`);
            //事后事件处理
            this.endEvent.forEach(element => {
              this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
                if (itemEvents['order'] == "back") {
                  switch (itemEvents['name']) {
                    case 'search':
                      break;
                    default:
                      let senddata = { value: "" };
                      try {
                        senddata['param0'] = itemEvents['param0'];
                        senddata['param1'] = itemEvents['param1'];
                        senddata['param2'] = itemEvents['param2'];
                      } catch (error) {

                      }
                      console.log("send", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                      this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                      break;
                  }
                }


              });
            });
            this.nzLoading = false;
            this.pageService.pageSpin[this.layoutid]['div'] = false;
            if (this.nzTimer) {
              clearInterval(this.nzTimer);
              this.nzTimer = null
            }

          } else {
            //还需等待
          }
        } else {
          this.message.create('error', `失败`);
          //事后事件处理
          this.endEvent.forEach(element => {
            this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {

              switch (itemEvents['name']) {
                case 'search':
                  break;
                default:
                  this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'])
                  break;
              }

            });
          });
          this.nzLoading = false;
          this.pageService.pageSpin[this.layoutid]['div'] = false;
          if (this.nzTimer) {
            clearInterval(this.nzTimer);
            this.nzTimer = null
          }
        }


      }, 300)
    }, 100);


  }
  async onFastClick() {
    //   this.notification.create(
    //     'success',
    //     'success1',
    //     'success2',
    // );
    if (this.sets.styles.nzFastClick) {


      if (this.sets.datas.nzProcedure.nzProcedureIsNeed) {


        let value = ""

        value = this.setService.pageDatas['form_' + this.layoutid].get(this.sets.styles.nzFastData.nzResetFormName).value;
        console.log("fastvalue", value)
        this.setService.pageDatas['form_' + this.layoutid].get(this.sets.styles.nzFastData.nzResetFormName).patchValue("")

        let serviceparams = this.pageService.getAllServiceParam(this.sets.datas['nzProcedure'], this.sets.datas['nzProcedure']['nzServiceParamDetail'], this.activatedRoute)
        // if (formData.datas.nzForm.nzFormType == 'insert') {
        //     this.formControlService.form_Reset(this.setService.pageDatas['form_' + this.layoutid], formData);
        // }


        console.log("获取业务参数", serviceparams)
        let procedureParams = {
          dynamicSql: serviceparams[0].name,
          paramMap: serviceparams[0].compositeValue
        }
        if (value != "") {
          for (let index = 0; index < serviceparams[0].compositeValue.length; index++) {
            const paramsdata = serviceparams[0].compositeValue[index];
            if (paramsdata.name == this.sets.styles.nzFastData.nzResetId) {
              //转换判断
              console.log('paramsdata', paramsdata.value);
              try {
                const formData = this.setService.pageDatas['form_data_' + this.layoutid];
                if (formData['datas']['nzForm']['nzFormGroupDatas'][this.sets.styles.nzFastData.nzResetId]['nzValue']['nzPipe'] === 'sn') {
                  paramsdata.value = await this.pageService.getNewSn(value);
                  console.log('snchange-end', paramsdata.value)

                } else {
                  paramsdata.value = value
                }
              } catch (error) {
                paramsdata.value = value
              }
              console.log('paramsdata', paramsdata.value);
              break;
            }
          }
        }

        //事件
        let endEvent = [];
        this.sets.datas.nzEvents.forEach(element => {
          switch (element) {

            case 'sendSimpleEvent':
              this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
                if (itemEvents['order'] == "front") {
                  switch (itemEvents['name']) {
                    case 'search':
                      break;
                    default:
                      let senddata = { value: "" };
                      try {
                        senddata['param0'] = itemEvents['param0'];
                        senddata['param1'] = itemEvents['param1'];
                        senddata['param2'] = itemEvents['param2'];
                      } catch (error) {

                      }
                      console.log("send-fast", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                      this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                      break;
                  }
                } else {
                  if (endEvent.indexOf(element) < 0) endEvent.push(element);
                }
              });

              break;

            default:
              break;
          }
        });
        if (typeof this.pageService.pageDatas[this.path] != "undefined" && typeof this.pageService.pageDatas[this.path]['SICBean'] != "undefined" && this.pageService.pageDatas[this.path]['SICBean'] != "") {
          procedureParams['resourceVerificationBean'] = this.pageService.pageDatas[this.path]['SICBean'];
        }
        console.log("获取处理业务参数2-body", JSON.stringify(procedureParams))

        this.httpService.postHttp(this.httpUrls.dynamicProcedure.url, procedureParams).subscribe(
          (data: any) => {
            console.log("业务data", JSON.stringify(data));
            this.pageService.doAfterProcedure(data, this.sets);

            this.pageService.doAfterProceduresecond(data, this.sets, this.activatedRoute);
            //事后事件处理
            endEvent.forEach(element => {
              this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
                if (itemEvents['order'] == "back") {
                  switch (itemEvents['name']) {
                    case 'search':
                      break;
                    default:
                      let senddata = { value: "" };
                      try {
                        senddata['param0'] = itemEvents['param0'];
                        senddata['param1'] = itemEvents['param1'];
                        senddata['param2'] = itemEvents['param2'];
                      } catch (error) {

                      }
                      console.log("send-fast", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                      this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                      break;
                  }
                }


              });
            });

            console.log(data.data);
          },
          (err: any) => {
            console.log("业务dataerr", JSON.stringify(err));
          });
      }
    } else {
      this.clickTest();
    }
  }
  otherFormCheckStatus = {};
  otherFormCheckStatusMsgs = {};
  clickTest() {
    this.otherFormCheckStatus = {};
    this.otherFormCheckStatusMsgs = {};
    //其它校验
    console.log("其它校验do", this.sets.datas.nzOtherFormCheck)
    if (this.sets.datas.nzOtherFormCheck.length > 0) {
      this.pageService.pageDatas['formCheckDataStatu' + this.layoutid] = false;
      console.log("其它校验", 'formCheckDataStatu', this.layoutid)
      this.sets.datas.nzOtherFormCheck.forEach(element => {
        switch (element.type) {
          case 'childTable':
            this.otherFormCheckStatus[element.type] = false;
            this.setService.sendEvent(element['datas']['blockid'], 'check_' + element.type, { blockid: this.blockid, num: element.datas.param0 })
            break;
          case 'hasTansfer':
            this.otherFormCheckStatus[element.type] = false;
            this.setService.sendEvent(element['datas']['blockid'], 'check_' + element.type, { blockid: this.blockid, num: element.datas.param0 })
            break;
          case 'hiddenvalue':
            if (this.otherFormCheckStatus[element.type] === undefined) {
              this.otherFormCheckStatus[element.type] = true;
              this.otherFormCheckStatusMsgs[element.type] = [];
            }

            const formid = this.setService.pageDatas['form_data_' + this.layoutid].datas.nzForm.nzFormGroupDatas[element['datas']['blockid']]['nzKey'];
            if (this.setService.pageDatas['form_' + this.layoutid].get(formid).value === '' || this.setService.pageDatas['form_' + this.layoutid].get(formid).value === null) {
              this.otherFormCheckStatus['hiddenvalue'] = false;
              if (element['datas']['param1'] !== '')
                this.otherFormCheckStatusMsgs[element.type].push(element['datas']['param1']);
            }

            break;
          default:
            break;
        }
      });
      setTimeout(() => {
        let status = true;
        console.log('其它校验otherFormCheckStatus', this.sets.datas.nzOtherFormCheck, this.otherFormCheckStatus, this.otherFormCheckStatusMsgs)
        for (let index = 0; index < this.sets.datas.nzOtherFormCheck.length; index++) {
          const type = this.sets.datas.nzOtherFormCheck[index]['type'];
          if (!this.otherFormCheckStatus[type]) {
            status = false;

            if (this.sets.datas.nzOtherFormCheck[index]['datas']['param1'] !== '') {
              if (this.otherFormCheckStatusMsgs[type] === undefined)
                this.message.error(this.sets.datas.nzOtherFormCheck[index]['datas']['param1']);
              else {
                if (this.otherFormCheckStatusMsgs[type].length >= 0) {
                  this.otherFormCheckStatusMsgs[type].forEach(msg => {
                    this.message.error(msg);
                  });

                }
              }
            }


            break;

          }
        }
        console.log("其它校验status", status)

        if (status) {
          this.pageService.pageDatas['formCheckDataStatu' + this.layoutid] = true;
          this.onClick();
        }

      }, 200);
    } else {
      this.onClick();
    }
  }

  onClick(): void {
    if (!this.sets.styles.nzOpen) {
      this.message.create('info', `功能暂未开放`);
    } else {

      //判断是否控制条数限制
      console.log("业务参数检测-nzServiceParam", this.sets.datas.nzProcedure.nzServiceParam);
      console.log("业务参数检测-nzServiceParamDetail", this.sets.datas.nzProcedure.nzServiceParamDetail);

      let serviceParamDetail = this.sets.datas.nzProcedure.nzServiceParamDetail;

      //let tableData = this.pageService.pageBlockDatas['']['checkValue'];
      let hastable = false;
      let tableData;
      for (const key in serviceParamDetail) {
        if (serviceParamDetail.hasOwnProperty(key)) {
          const element = serviceParamDetail[key];
          if (element.type == "1") {
            hastable = true;

            tableData = this.pageService.pageBlockDatas[element.source]['checkValue'];
          } else {


          }


        }
      }

      if (hastable) {
        //如果是表格类型，进行条件限制


        console.log("跳转类型", this.sets.datas.nzJumpMode)
        switch (this.sets.datas.nzJumpMode) {

          case "none":
            if (this.sets.styles.nzConfirm.nzShow) {
              this.modalService.confirm({
                nzTitle: this.sets.styles.nzConfirm.nzTitle,
                nzContent: this.sets.styles.nzConfirm.nzContent,
                nzOnOk: () => this.onClickEvents()
              });
            }
            else {
              this.onClickEvents();
            }

            break;

          case "single":
            console.log("勾选一条记录");
            if (typeof tableData != 'undefined') {

              if (tableData.length != 1) {
                this.modalService.info({
                  nzTitle: "提示",
                  nzContent: "请勾选一条记录"
                });
              } else {
                if (this.sets.styles.nzConfirm.nzShow) {
                  this.modalService.confirm({
                    nzTitle: this.sets.styles.nzConfirm.nzTitle,
                    nzContent: this.sets.styles.nzConfirm.nzContent,
                    nzOnOk: () => this.onClickEvents()
                  });
                }
                else {
                  this.onClickEvents();
                }

              }
            } else {
              this.modalService.info({
                nzTitle: "提示",
                nzContent: "请勾选一条记录"
              });

            }

            break;

          case "multiple":

            console.log("勾选多条记录");

            if (typeof tableData != 'undefined') {

              if (tableData.length > 0) {
                if (this.sets.styles.nzConfirm.nzShow) {
                  this.modalService.confirm({
                    nzTitle: this.sets.styles.nzConfirm.nzTitle,
                    nzContent: this.sets.styles.nzConfirm.nzContent,
                    nzOnOk: () => this.onClickEvents()
                  });
                }
                else {
                  this.onClickEvents();
                }

              } else {
                this.modalService.info({
                  nzTitle: "提示",
                  nzContent: "请勾选一条记录"
                });
              }
            } else {
              this.modalService.info({
                nzTitle: "提示",
                nzContent: "请勾选一条记录"
              });
            }


            break;

        }
        console.log("业务参数检测-表格数据", tableData);


      } else {
        if (this.sets.styles.nzConfirm.nzShow) {
          this.modalService.confirm({
            nzTitle: this.sets.styles.nzConfirm.nzTitle,
            nzContent: this.sets.styles.nzConfirm.nzContent,
            nzOnOk: () => this.onClickEvents()
          });
        }
        else {
          this.onClickEvents();
        }
      }



    }

  }


  Listening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid);
      this.setService.events[this.blockid].subscribe(
        data => {
          console.log("Listening:", data['type'], JSON.stringify(data));
          let array0 = []
          let array1 = []
          switch (data['type']) {

            case 'pageShow':

              console.log("data.datas.value", data.datas.value, data.datas.param0)
              array0 = (data.datas.param0 + "").split(",");
              array1 = (data.datas.param1 + "").split(",");
              if (array0.indexOf(data.datas.value) >= 0) {
                //disable
                this.sets['styles']['nzShow'] = false;

              } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
                // enable
                this.sets['styles']['nzShow'] = true;
                // this.form.get(this.nzFormGroupData.nzKey).enable();
              }
              break;
            case 'check_childTable_ans':
              if (data.datas)
                this.otherFormCheckStatus['childTable'] = true;

              break;
            case 'check_hasTansfer_ans':
              if (data.datas)
                this.otherFormCheckStatus['hasTansfer'] = true;

              break;
            case 'fastForm':

              console.log("data.datas.value", data.datas.value, data.datas.param0)
              array0 = (data.datas.param0 + "").split(",");
              array1 = (data.datas.param1 + "").split(",");
              if (array0.indexOf(data.datas.value) >= 0) {
                //disable
                this.sets.styles['nzFastClick'] = true;
                this.setService.pageDatas['form_data_' + this.layoutid].datas.nzForm.nzFastClick = true;
              } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
                // enable
                this.sets.styles['nzFastClick'] = false;
                this.setService.pageDatas['form_data_' + this.layoutid].datas.nzForm.nzFastClick = false;
                // this.form.get(this.nzFormGroupData.nzKey).enable();
              }
              break;
            case 'click':
              this.onFastClick();
              break;

            default:
              break;
          }
        }
      )
    }, !this.static ? 100 : 0);


  }

}
